import {useEffect, useState} from 'react'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useLoginCookie from 'shared/model/useLoginCookie'
import {ROLE_EXTERNAL_ADMIN} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetTicketStatisticsExport = () => {
	const [fetchResult, setFetchResult] = useState(null)
	const [isLoading, setIsLoading] = useState(false)
	const [, setAlert] = useAlertModalAtom()
	const [cookie] = useLoginCookie()
	const [userRole] = useRoleCookie()

	const exportTicketStatistics = async () => {
		try {
			setIsLoading(true)
			setFetchResult(null)
			const rolePath = getApiRolePath(userRole)
			let url = `/${rolePath}/ticket-statistics/export?timestamp=${Date.now()}`

			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}${url}`,
				{
					method: 'GET',
					headers: {
						token: cookie,
					},
				}
			)

			setFetchResult({
				statusCode: response.status,
				data: response.ok ? await response.blob() : await response.json(),
			})
		} catch (error) {
			setFetchResult({
				statusCode: 500,
				data: {message: '서버 통신 중 문제가 발생하였습니다.'},
			})
		} finally {
			setIsLoading(false)
		}
	}

	useEffect(() => {
		if (!fetchResult) return

		switch (fetchResult?.statusCode) {
			case 200:
				// Export successful - handle file download
				if (fetchResult?.data) {
					const url = window.URL.createObjectURL(fetchResult.data)
					const link = document.createElement('a')
					link.href = url
					link.download = `ticket-usage-overview.xlsx`
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
					window.URL.revokeObjectURL(url)
					setFetchResult(null)
				}
				break
			case 400:
				if (fetchResult?.data?.error_code === 'INVALID_YEAR') {
					setAlert('유효하지 않은 연도입니다.')
				} else {
					setAlert('내보내기 요청 형식이 잘못되었습니다.')
				}
				setFetchResult(null)
				break
			case 404:
				setAlert('내보내기 데이터를 찾을 수 없습니다.')
				setFetchResult(null)
				break
			case 500:
				setAlert('내보내기 중 서버 오류가 발생했습니다.')
				setFetchResult(null)
				break
			default:
				break
		}
	}, [fetchResult, setAlert])

	return [fetchResult, exportTicketStatistics, isLoading]
}

export default useGetTicketStatisticsExport
